<div class="app app-container">
  <div class="background-image">
    <router-outlet></router-outlet>
  </div>
</div>
